import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  input[type="button"], input[type="submit"], button[type="button"] {
    border-radius: 4px;
    height: 20px;
    width: 20px;
  }
`;
